import { useContext } from 'react';

import { StoreContext } from '../context/store';

export const useCustomStore = () => useContext(StoreContext);
